module.exports = __webpack_public_path__ + "static/media/parikrama.353ffa7e.png";